import type { Basic } from "@medplum/fhirtypes";
import { BASIC_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Basic resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * The Basic collection is scoped to chart-edit-lock resources (see
 * `createBasicCollectionConfig`). Other Basic uses would need a separate
 * collection + subscription pair.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useBasicSubscription = createSubscriptionHook<Basic>("Basic", BASIC_COLLECTION_NAME);
